'use client';

import { useEffect } from 'react';
import { initWebVitals, createVitalsDebugPanel } from '@/lib/vitals';

export function WebVitals() {
  useEffect(() => {
    // Initialize Web Vitals monitoring
    initWebVitals();

    // Show debug panel in development
    if (process.env.NODE_ENV === 'development') {
      const debugSender = createVitalsDebugPanel();
      if (debugSender) {
        // Re-initialize with debug sender
        import('web-vitals').then((webVitals) => {
          if (webVitals.onCLS) webVitals.onCLS(debugSender);
          if (webVitals.onFCP) webVitals.onFCP(debugSender);
          if (webVitals.onINP) webVitals.onINP(debugSender);
          if (webVitals.onLCP) webVitals.onLCP(debugSender);
          if (webVitals.onTTFB) webVitals.onTTFB(debugSender);
        }).catch(error => {
          console.warn('Failed to initialize debug Web Vitals:', error);
        });
      }
    }
  }, []);

  return null;
}